module.exports = __webpack_public_path__ + "img/zyd_logo.42e7ef48.png";